import { createRoute, useNavigate } from '@tanstack/solid-router'
import { appLayoutRoute } from '../app-layout.route'
import { WellboresPage } from '../../WellboresPage'
import { editorSearchSchema } from '../search-schemas'

// /wellbores — CRUD-каталог стволов (OSDU Wellbore). Список + редактор,
// открытие редактора через search-параметры (?edit=N / ?new=1), как у
// /wells и /fields — чтобы не размонтировать список при переключении
// list↔editor.
export const wellboresRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/wellbores',
  validateSearch: editorSearchSchema,
  component: WellboresRouteComponent,
})

function WellboresRouteComponent() {
  const search = wellboresRoute.useSearch()
  const navigate = useNavigate()
  return (
    <WellboresPage
      wellboreId={search().edit ?? null}
      create={search().new === 1}
      onOpen={(id) => navigate({ to: '/wellbores', search: { edit: id } })}
      onCreate={() => navigate({ to: '/wellbores', search: { new: 1 } })}
      onBack={() => navigate({ to: '/wellbores', search: {} })}
    />
  )
}
